@if (!loading) {
  <sb-page-network-bookings [inDeviceContext]="deviceId"></sb-page-network-bookings>
}
